import { useGrowthbookSubdomainFlags } from 'src/common/hooks/useGrowthbookSubdomainFlags';
import FlexibleStepper from 'src/components/FlexibleStepper';
import LoaderOverlay from 'src/components/Loader';
import useAuthContext from 'src/context/AuthProvider/useAuthContext';
import { queryClient } from 'src/context/QueryProvider/QueryClient';
import EmailVerificationStep from 'src/features/auth/presentation/components/VerificationStepper/EmailVerificationStep';
import IdVerificationStatusStep from 'src/features/auth/presentation/components/VerificationStepper/IdVerificationStatusStep';
import PhoneVerificationStep from 'src/features/auth/presentation/components/VerificationStepper/PhoneVerifcationStep';

export default function VerificationStepper() {
  const { session } = useAuthContext();

  const isPhoneVerificationEnabled = useGrowthbookSubdomainFlags(
    'ENABLE_SIGNUP_PHONE_OTP',
    false
  );
  const isEmailVerificationEnabled = useGrowthbookSubdomainFlags(
    'ENABLE_SIGNUP_EMAIL_OTP',
    false
  );
  const isDocumentVerificationEnabled = useGrowthbookSubdomainFlags(
    'ENABLE_VERIFY_ID_PROVIDER',
    false
  );

  const isEmailVerified = session?.user.email_verified;
  const isPhoneVerified = session?.user.phone_verified;
  const isIdVerified = session?.user.id_verified;

  const showPhoneVerification = isPhoneVerificationEnabled && !isPhoneVerified;
  const showEmailVerification = isEmailVerificationEnabled && !isEmailVerified;
  const showIdVerification = isDocumentVerificationEnabled && !isIdVerified;

  const someFieldIsUndefined =
    !!session &&
    (session?.user.email_verified === undefined ||
      session?.user.phone_verified === undefined);

  const handleVerificationSuccess = () => {
    queryClient.invalidateQueries({ queryKey: ['currentUser'] });
  };

  if (someFieldIsUndefined) {
    return <LoaderOverlay />;
  }

  return (
    <FlexibleStepper>
      {showEmailVerification && (
        <EmailVerificationStep onSuccess={handleVerificationSuccess} />
      )}
      {showPhoneVerification && (
        <PhoneVerificationStep onSuccess={handleVerificationSuccess} />
      )}
      {showIdVerification && (
        <IdVerificationStatusStep onSuccess={handleVerificationSuccess} />
      )}
    </FlexibleStepper>
  );
}
